<template>
  <div class="dialog-host">
    <component
      v-for="item in stack"
      :key="item.id"
      :is="resolveDialog(item.type)"
      v-bind="item.props"
      @resolve="onResolve(item.id, $event)"
      @reject="onReject(item.id, $event)"
    />
  </div>
</template>

<script>
const files = require.context('./dialogs', false, /[A-Z]\w*Dialog\.vue$/)

const dialogMap = files.keys().reduce((map, key) => {
  const component = files(key).default
  const name = key.replace('./', '').replace('.vue', '')
  map[name] = component
  return map
}, {})

export default {
  name: 'DialogHost',
  data() {
    return {
      originalParent: null,
      originalNextSibling: null,
    }
  },
  computed: {
    stack() {
      return this.$dialog.state.stack
    }
  },
  mounted() {
    if (typeof document === 'undefined' || !this.$el) return

    this.originalParent = this.$el.parentNode
    this.originalNextSibling = this.$el.nextSibling
    document.body.appendChild(this.$el)
  },
  beforeDestroy() {
    if (!this.$el || !this.originalParent) return

    if (this.originalNextSibling && this.originalNextSibling.parentNode === this.originalParent) {
      this.originalParent.insertBefore(this.$el, this.originalNextSibling)
      return
    }

    this.originalParent.appendChild(this.$el)
  },
  methods: {
    resolveDialog(type) {
      return dialogMap[type] || null
    },
    onResolve(id, payload) {
      this.$dialog.close(id, payload, false)
    },
    onReject(id, payload) {
      this.$dialog.close(id, payload, true)
    }
  }
}
</script>
